<div>

  <!-- Header / Action Bar -->
  <header class="d-flex align-items-center justify-content-between mb-4 bg-body p-3 rounded-3 shadow-sm border">
    <div>
      <h5 class="mb-0 fw-bold text-body">KBZ Payment Transactions</h5>
      <small class="text-muted">Manage and monitor KBZPay payment records</small>
    </div>

    <nav>
      <ul class="nav gap-2 align-items-center list-unstyled mb-0">
        <!-- Filter Button with Dropdown -->
        <li class="dropdown">
          <button type="button" class="btn btn-outline-secondary d-flex align-items-center px-3 fw-medium"
            data-bs-toggle="dropdown" aria-expanded="false" data-bs-auto-close="outside">
            <i class="fa-solid fa-filter me-2 text-muted"></i>
            <span>Filter Options</span>
          </button>

          <div class="dropdown-menu p-4 border-0 rounded-3 shadow-lg mt-2" style="min-width: 340px;">
            <div class="d-flex justify-content-between align-items-center mb-3 border-bottom pb-2">
              <h5 class="mb-0 fw-bold text-secondary">Filter Records</h5>
              <i class="fa-solid fa-sliders text-muted"></i>
            </div>

            <form>
              <!-- Result Selection -->
              <div class="mb-3">
                <label for="result" class="form-label small fw-semibold text-muted text-uppercase">Result Status</label>
                <select class="form-select border-2" id="result" name="result" [(ngModel)]="results">
                  <option value="ALL">ALL</option>
                  <option value="SUCCESS">SUCCESS</option>
                  <option value="FAIL">FAIL</option>
                  <option value="PENDING">PENDING</option>
                </select>
              </div>

              <!-- Validate Transaction Selection -->
              <div class="mb-3">
                <label for="validateTransaction" class="form-label small fw-semibold text-muted text-uppercase">Validate
                  Transaction</label>
                <select class="form-select border-2" id="validateTransaction" name="validateTransaction"
                  [(ngModel)]="validateTransaction">
                  <option value="ALL">ALL</option>
                  <option value="TRUE">TRUE</option>
                  <option value="FALSE">FALSE</option>
                </select>
              </div>

              <!-- Date Range Selection -->
              <div class="row g-2 mb-3">
                <div class="col-6">
                  <label for="startDate" class="form-label small fw-semibold text-muted text-uppercase">Start
                    Date</label>
                  <input type="date" class="form-control border-2" id="startDate" name="startDate"
                    [(ngModel)]="startDate" />
                </div>
                <div class="col-6">
                  <label for="endDate" class="form-label small fw-semibold text-muted text-uppercase">End Date</label>
                  <input type="date" class="form-control border-2" id="endDate" name="endDate" [(ngModel)]="endDate" />
                </div>
              </div>

              <!-- Limit Input with Validation -->
              <div class="mb-4">
                <label for="limit" class="form-label small fw-semibold text-muted text-uppercase">Limit (1 -
                  100,000)</label>
                <input type="number" class="form-control border-2" id="limit" name="limit" [(ngModel)]="limit"
                  #limitInput="ngModel" required min="1" max="100000" [ngClass]="{
                    'is-invalid': limitInput.invalid && limitInput.touched,
                    'is-valid': limitInput.valid && limitInput.touched
                  }" />
                @if (limitInput.invalid && limitInput.touched) {
                <div class="invalid-feedback">
                  @if (limitInput.errors?.['required']) { Limit is required. }
                  @if (limitInput.errors?.['min']) { Must be at least 1. }
                  @if (limitInput.errors?.['max']) { Cannot exceed 100,000. }
                </div>
                }
              </div>

              <!-- Search Button -->
              <button type="button" class="btn btn-primary w-100 py-2 fw-medium shadow-sm" (click)="saveFilter()">
                <i class="fa-solid fa-magnifying-glass me-2"></i> Apply Filters
              </button>
            </form>
          </div>
        </li>

        <!-- Download Button -->
        <li>
          <button type="button" class="btn btn-success d-flex align-items-center px-3 fw-medium shadow-sm"
            [disabled]="apiDownloadLoading() && !downloadFile" data-bs-toggle="modal" data-bs-target="#downloadCSVModal">
            @if(apiDownloadLoading()) {
            <span class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
            <span>Downloading...</span>
            } @else {
            <i class="fa-solid fa-file-csv me-2 fs-5"></i>
            <span>Download CSV</span>
            }
          </button>
        </li>
      </ul>
    </nav>
  </header>

  <!-- Table Card Wrapper -->
  <div class="card border-0 shadow-sm rounded-3 overflow-hidden mb-4 bg-body">
    <div class="table-responsive">
      <table class="table table-hover align-middle mb-0 custom-table">

        <!-- Table Header Structure -->
        <thead class="table-light text-body-secondary text-uppercase font-xs border-bottom">
          <tr>
            <th class="ps-3 py-3 fw-bold" style="width: 60px;">No</th>
            <th class="py-3 fw-bold">Payment Phone</th>
            <th class="py-3 fw-bold">Payment Name</th>
            <th class="py-3 fw-bold">Response Code</th>
            <th class="py-3 fw-bold text-center" style="width: 120px;">Result</th>
            <th class="py-3 fw-bold">Code</th>
            <th class="py-3 fw-bold">Message</th>
            <th class="py-3 fw-bold text-end">Total Amount</th>
            <th class="py-3 fw-bold text-center">Currency</th>
            <th class="py-3 fw-bold">MM Order ID</th>
            <th class="pe-3 py-3 fw-bold">Success Time</th>
          </tr>
        </thead>

        <!-- Table Body Container -->
        <tbody class="border-top-0 small text-body">
          @for (data of kbzpayPaymentTransactionRespLst() | paginate: { itemsPerPage: pageSize(), currentPage: page(),
          totalItems: allTotal() }; track $index) {
          <tr class="align-middle">
            <!-- Serial Position -->
            <td class="ps-3 text-body-secondary fw-medium">{{ data.srNo }}</td>

            <!-- Identifiers -->
            <td>
              <span class="font-monospace text-body fw-medium">{{ data.paymentPhone }}</span>
            </td>
            <td class="text-body fw-medium">{{ data.paymentName }}</td>

            <!-- HTTP Status Error Code Badge -->
            <td>
              <span class="badge bg-body-tertiary text-body-secondary border px-2 py-1 font-monospace">
                {{ data.errorStatusCode }}
              </span>
            </td>

            <!-- System Status Result Operation Matrix Badges -->
            <td class="text-center">
              <span class="badge rounded-pill px-2.5 py-1.5 font-xs fw-semibold tracking-wide" [ngClass]="{
                  'bg-success-subtle text-success-emphasis border border-success-subtle': data.result === 'SUCCESS',
                  'bg-danger-subtle text-danger-emphasis border border-danger-subtle': data.result === 'FAIL',
                  'bg-warning-subtle text-warning-emphasis border border-warning-subtle': data.result === 'PENDING'
                }">
                {{ data.result }}
              </span>
            </td>

            <td><span class="text-body-secondary font-xs">{{ data.code }}</span></td>
            <td>
              <span class="text-truncate d-inline-block style-msg text-body-secondary font-xs" style="max-width: 150px;"
                [title]="data.msg">
                {{ data.msg }}
              </span>
            </td>

            <!-- Value Quantification Core Data Blocks -->
            <td class="text-end fw-bold text-body font-monospace">{{ data.totalAmount | number }}</td>
            <td class="text-center">
              <span class="badge bg-body-secondary text-body-secondary border border-secondary-subtle font-xs">
                {{ data.transCurrency }}
              </span>
            </td>

            <td><span class="font-monospace font-xs text-body-secondary">{{ data.mmOrderId }}</span></td>
            <td class="pe-3 text-body-secondary font-xs">{{ data.paySuccessTime | dateFormat }}</td>
          </tr>
          } @empty {

          <!-- Empty Ledger Record Fallback Screen -->
          <tr>
            <td colspan="11" class="text-center py-5 bg-body-tertiary">
              <div class="py-4 max-w-sm mx-auto">

                <!-- Icon Frame Container with built-in subtle adaptive ring -->
                <div class="d-inline-flex align-items-center justify-content-center bg-body rounded-circle mb-3 border"
                  style="width: 64px; height: 64px;">
                  <i class="fa-solid fa-folder-open fs-3 text-body-secondary opacity-75"></i>
                </div>

                <!-- Informational Status Summary Elements -->
                <h6 class="fw-semibold text-body mb-1">No Transactions Found</h6>
                <p class="text-body-secondary font-xs mb-0 px-3">
                  We couldn't find any transaction records matching your current filter criteria.
                </p>

              </div>
            </td>
          </tr>
          }
        </tbody>
      </table>
    </div>
  </div>


  <!-- Pagination Context Section -->
  <div class="d-flex justify-content-center mt-4">
    <nav aria-label="Transaction table pagination" class="custom-pagination">
      <pagination-controls [maxSize]="15" previousLabel="&laquo;" nextLabel="&raquo;" [responsive]="true"
        (pageChange)="handlePageChange($event)"></pagination-controls>
    </nav>
  </div>

</div>

<!-- Floating Mini Card Indicator -->
@if (loading()) {
<div class="position-fixed bottom-0 end-0 m-2 z-3 p-3 bg-body card border-info border-opacity-25 shadow-sm d-flex flex-row align-items-center gap-2" style="backdrop-filter: blur(4px);">
  <!-- Mini Spinner -->
  <div class="spinner-border text-info" style="width: 1rem; height: 1rem; border-width: 2px;" role="status">
    <span class="visually-hidden">Loading...</span>
  </div>

  <!-- Text Badge Layout (Uses your global micro utilities) -->
  <div class="font-monospace text-info fw-bold tracking-widest text-uppercase pe-1 font-xs">
    Loading...
  </div>
</div>
}

<!-- Refined Download CSV Modal -->
<div class="modal fade" id="downloadCSVModal" data-bs-backdrop="static" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content border-0 shadow-lg rounded-3">

      <!-- Modal Header -->
      <div class="modal-header border-bottom-0 pb-0 pt-4 px-4">
        <h5 class="modal-title fw-bold text-dark d-flex align-items-center">
          <i class="fa-solid fa-file-csv text-success me-2 fs-4"></i>
          <span>Export Transaction Ledger</span>
        </h5>
        <button type="button" class="btn-close shadow-none" data-bs-dismiss="modal" aria-label="Close"
          [disabled]="apiDownloadLoading()"></button>
      </div>

      <!-- Modal Body -->
      <div class="modal-body py-3 px-4">
        <p class="text-muted small mb-3">Please specify a file name below. Your generated file will export directly as a
          structured comma-separated values (.csv) spreadsheet.</p>

        <!-- Modern Floating Input Group -->
        <div class="form-floating mb-1">
          <input type="text" class="form-control border-2 shadow-none" id="fileNameInput" placeholder="Enter file name"
            [(ngModel)]="downloadFileName" [disabled]="apiDownloadLoading()" />
          <label for="fileNameInput" class="text-muted fw-medium">File Name (e.g., transaction_report)</label>
        </div>
      </div>

      <!-- Modal Footer -->
      <div class="modal-footer border-top-0 pt-2 pb-4 px-4">
        <button type="button" class="btn btn-light px-3 fw-semibold text-secondary" data-bs-dismiss="modal"
          [disabled]="apiDownloadLoading()">
          Cancel
        </button>

        <button type="button" class="btn btn-primary px-4 fw-semibold shadow-sm d-flex align-items-center"
          (click)="downloadFile()" [disabled]="!downloadFileName || apiDownloadLoading()">
          @if (apiDownloadLoading()) {
          <span class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
          <span>Generating...</span>
          } @else {
          <i class="fa-solid fa-cloud-arrow-down me-2"></i>
          <span>Download CSV</span>
          }
        </button>
      </div>

    </div>
  </div>
</div>